import { sleep } from "../../../library-js/animation/sleep";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { Overlay } from "./Overlay";

class EmailOverlayElement extends HTMLElement
{
  _conditionsChecked:boolean = false;
  _conditionsOptional:boolean = false;
  _emailValid:boolean = false;


  public static convert( element:Element )
  {
    let eo = element as EmailOverlayElement;
    eo._conditionsChecked = false;
    eo._emailValid = false;
    eo._conditionsOptional = false;

    return eo;
  }

  public static canSend( eo:EmailOverlayElement )
  {
    return ( eo._conditionsOptional || eo._conditionsChecked ) && eo._emailValid;
  }
}

export class EmailOverlay
{
  static readonly type = new ElementType( "email-overlay" );
  static readonly sendRequest = new ElementType( "send-request" );
  static readonly thanks = new ClassFlag( "thanks" );
  static readonly problems = new ClassFlag( "problems" );

  static open( template:string, onSend:( email:string, password:string )=>Promise<boolean>, conditionsOptional:boolean = false )
  {
    let rj = Rokojori.$;
    let content = rj.templatesManager.createTemplate( template, document );    
    
    let eo = EmailOverlayElement.convert( content );
    eo._conditionsOptional = conditionsOptional;
    
    let emailOverlay = EmailOverlay.type.query( content );
    rj.templatesManager.processElement( eo );  
    rj.pageHandler.resolveRootPaths( eo );

    let sendRequest = EmailOverlay.sendRequest.query( eo ) as HTMLElement;
    console.log( sendRequest, "from", content );
    let language = rj.pageHandler.currentLanguage;  

    let checkBoxSelector = ElementType.input.selectorWith( [ AttributeValue.type_checkbox ] );
    let checkboxes = HTMLEditor.nodeListToArray( eo.querySelectorAll( checkBoxSelector ) ) as HTMLInputElement[];  
    let checkBox = checkboxes.find( cb => ElementAttribute.data_lang.hasParentWithValue( cb, language ) );

    let emailSelector = ElementType.input.selectorWith( [ AttributeValue.type_email ] );
    let pwSelector = ElementType.input.selectorWith( [ AttributeValue.type_password ] );
    let emails = HTMLEditor.nodeListToArray( eo.querySelectorAll( emailSelector ) ) as HTMLInputElement[];  
    let passwords = HTMLEditor.nodeListToArray( eo.querySelectorAll( pwSelector ) ) as HTMLInputElement[];  

    let emailInput = emails.find( em => ElementAttribute.data_lang.hasParentWithValue( em, language ) );
    let passwordInput = passwords.find( pw => ElementAttribute.data_lang.hasParentWithValue( pw, language ) );

    OnClick.add( sendRequest,
      async ()  =>
      {
        let email = emailInput.value;
        let password = passwordInput?.value || null;
        let success = await onSend( email, password );
        //this.joinNewsletter( channel, email );

        if ( success )
        {
          this.thanks.set( emailOverlay );
        }
        else
        {
          this.problems.set( emailOverlay );
        }
        
        
        
        await sleep( 1500 )
        Overlay.hide();        
      }
    )

   
    OnChange.add( 
      checkBox, () => 
      {
        eo._conditionsChecked = checkBox.checked;
        
        console.log( 
          eo._conditionsChecked, 
          eo._emailValid
        );

        ClassFlag.enabled.setAs( sendRequest, EmailOverlayElement.canSend( eo ) );
      }
    );
    
    let checkEmailInput = () => 
    {
      eo._emailValid = /.+@.+\..+/.test( emailInput.value );
      
      console.log( 
        eo._conditionsChecked, 
        eo._emailValid
      );
      
      ClassFlag.enabled.setAs( sendRequest, EmailOverlayElement.canSend( eo ) );
    };

    OnChange.add( emailInput, checkEmailInput );
    OnInput.add( emailInput, checkEmailInput );
    OnKeyUp.add( emailInput, 
      ( k )=>
      { 
        if ( k.key === "Enter" )
        {
          emailInput.blur();
        }
      } 
    )
        
      
    

    Overlay.show( content as HTMLElement );
  }
}